import { isPlatformServer } from "@angular/common";
import { Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { makeStateKey } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-ai-image-collection",
  templateUrl: "./ai-image-collection.component.html",
  styleUrls: ["./ai-image-collection.component.scss"],
})
export class AIIllustrationCollectionComponent implements OnInit {
  id = "";
  cate = "";
  collectionData: any = {};
  collectionsFiles: any = [{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}];
  illusData: any = {};
  ILLUS_KEY = makeStateKey<any>("illusData");
  loader = true;
  imageLoad = true;
  constructor(
    private afs: AngularFirestore,
    public router: Router,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    // this.route.queryParams.subscribe((params) => {
    //   this.id = params["slug"];
    //   //console.log(params);
    //   //console.log(this.id);

    //   // })
    //   // this.route.params.subscribe((params) => {
    //   // this.id = params["id"];
    //   // this.cate = params["cate"];

    //   //console.log(this.id);
    //   //console.log(this.cate);
    //   //console.log(params);

    //   if (this.id) {
    //     // this.getSingleService(this.id).then((data) => {
    //     //   data.subscribe((singleservice) => {
    //     //     //console.log(singleservice);
    //     //     this.collectionData = singleservice[0];
    //     //     this.collectionData?.collectionName ? this.getCollectionFileData() : null;
    //     //   });
    //     // });
    //   }
    // });
  }

  ngOnInit(): void {
    this.collectionData = this.route.snapshot.data["illustration"];

    if(this.collectionData?.slug) {  
      this.getCollectionFileData();
    }
    // this.id = this.illusData?.id;
    // this.titleStr = this.route.snapshot.paramMap.get("slug");
    //console.log("this.illusData", this.collectionData);
    const isServer = isPlatformServer(this.platformId);
    //console.log("isServer (ngOnInit):", isServer);
  }

  async getCollectionFileData() {
    //console.log("getCollectionFileData called");
    this.collectionsFiles = [];
    const get = await this.afs.collection(`filesMaster/`, (res) => {
      return this.cate
        ? res
            .where("collections", "==", this.collectionData?.collectionName)
            .where("categories", "array-contains", this.cate)
            .where("status", "==", "Published")
        : res
            .where("collections", "==", this.collectionData?.collectionName)
            .where("status", "==", "Published");
    });

    const getdata = await get.valueChanges({ idField: "id" });
    getdata.subscribe((fdata) => {
      this.collectionsFiles = fdata;

    this.loader = false;
    this.imageLoad = false;
      //console.log(this.collectionsFiles);
    });
  }

  async getSingleService(id) {
    // const get = await this.afs.collection(`collectionMaster/`, (res) => {
    //   return res.where("collectionName", "==", id).orderBy("createdOn", "desc");
    // });
    // const getdata = await get.valueChanges();
    // return getdata;
  }
}
